export default "__VITE_ASSET__DuN7f$fW__ 480w, __VITE_ASSET__YkiA0Gv5__ 768w, __VITE_ASSET__BHoZTB5b__ 1200w, __VITE_ASSET__D2U4xeQS__ 1824w";